// extracted by mini-css-extract-plugin
export default {"background":"Customers_background__DG2Iw","row":"Customers_row__xBaCz","col":"Customers_col__wSZX5","card":"Customers_card__rpaR0"};